/* global NetworkConfig */
import React from 'react';
import PropTypes from 'prop-types';
import { getFontHelmetTag, setHelmetTags } from 'helpers/HelmetHelper';
import { getFontClassName } from 'helpers/ContentHelper';
import classNames from 'classnames';
import style from './ErrorFallbackStyle.module.scss';

const ErrorFallback = props => {
  const { error } = props;
  if (!error) return null;

  const { headerTags } = NetworkConfig;
  const data = {
    ...headerTags,
  };
  const {
    errorFatal_header: headerText,
    errorFatal_message: bodyText,
    errorFatal_buttonLabel: buttonText,
  } = window.Language;
  const { errorFatalDestination, appDownload } = window.ExternalConfig;
  const { promoUrl } = appDownload;
  const buttonLink = promoUrl || errorFatalDestination;

  return (
    <div className={classNames([style.container, getFontClassName(style)])}>
      {setHelmetTags(data)}
      {getFontHelmetTag()}
      <div className={style.content}>
        <h1 className={style.header}>{headerText}</h1>
        <div className={style.body}>{bodyText}</div>
        <a className={style.button} href={buttonLink}>
          {buttonText}
        </a>
      </div>
    </div>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.shape({}).isRequired,
};
export default ErrorFallback;
